<!-- <div class="iframe">
  <span>Vorschau wird geladen</span>
  <iframe
    [src]="mapUrl"
    frameborder="0"
  ></iframe>
</div> -->

<div class="modal-wrapper">
  <div class="modal-header">
    <h5 class="modal-title" i18n="@@AddPublicPricingHeader">Öffentlichen Tarif hinzufügen</h5>
    <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancelClick()"></button>
  </div>
  <div class="modal-body">
    <app-create-public-pricing (newEntityEvent)="newEntityEvent($event)" #createPublicPricingComponent></app-create-public-pricing>
  </div>
  <div class="modal-footer">
    <button type="button" id="cancel" class="btn btn-yellow" data-bs-dismiss="modal" (click)="onCancelClick()" i18n="@@CancelButton">Schließen</button>
    <form [formGroup]="formService.form" (ngSubmit)="createPublicPricingComponent.onSubmit(formService.form.value)">
      <button type="submit" id="add" class="btn btn-primary" [disabled]="!formService.form.valid" i18n="@@AddButton">Hinzufügen</button>
    </form>
  </div>
</div>
